import { Alert } from "@mui/material";
import { useAsync2 } from "nate-react-api-helpers";
import { useEffect } from "react";
import { api } from "../../api/API";
import { useSyncedRef } from "../../misc/SyncedRef";

// InviteEmail names the team an invite is for, and hands its address to the form
export function InviteEmail(props: { token: string; onEmail: (email: string) => void }) {
    const invite = useAsync2(input => api.teams.getInvite(input), { token: props.token }, [props.token]);
    const onEmail = useSyncedRef(props.onEmail);

    const email = invite.result?.email || "";
    useEffect(() => {
        if (email) onEmail.current(email);
    }, [email, onEmail]);

    if (!invite.result) return invite.LoadingOrErrorElement;

    return (
        <Alert severity="info" sx={{ mb: 2 }}>
            Create an account to join {invite.result.teamName}.
        </Alert>
    );
}
